import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "material-ui";

export class DeleteErrorDialog extends React.Component {
    render() {

        const {open, handleClose} = this.props;

        return (
            <Dialog
                open={open}>
                <DialogTitle>削除エラー</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        法令チェックに割り当てられたカテゴリーは削除できません。<br/>
                        別カテゴリーを割り当てた後、削除してください。
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        閉じる
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/regulation/dialog/delete_error.js